export class ListFilter {
  [param: string]: string | string[];
}
